import { useState, useEffect } from "react";
import "../../../App.css";
import Listdelete from "./ListDelete";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import Add from "./Add";

const baseURL = process.env.REACT_APP_API_JOBS;
function Relatives(props) {
  const { visible, moamad } = props;
  const [counter, setCounter] = useState(0);
  const [rltvOptions, setRltvOptions] = useState();
  const [departmentsList, setDepartmentsList] = useState([]);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "rltvtype/", {
          signal: controller.signal,
        });
        if (isMounted) {
          setRltvOptions(response.data[0].rltvOptions);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "department/", {
          signal: controller.signal,
        });
        if (isMounted) {
          setDepartmentsList(response.data);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
  }, []);
  const increment = () => {
    setCounter(counter + 1);
  };

  if (!visible) return;
  return (
    <>
      <Add
        increment={increment}
        counter={counter}
        moamad={moamad}
        rltvOptions={rltvOptions}
        departmentsList={departmentsList}
      />
      <Listdelete
        increment={increment}
        counter={counter}
        setCounter={setCounter}
        moamad_id={moamad.id}
        rltvOptions={rltvOptions}
        departmentsList={departmentsList}
      />
    </>
  );
}

export default Relatives;
